module.exports = __webpack_public_path__ + "static/media/glanum_strasse_tn.a99812a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_strasse_tn.jpg
// module id = 268
// module chunks = 0